function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import { asSingleStyleConfig } from '../../../../utils/theme';
var iconSharedStyles = {
  position: 'absolute',
  top: '50%',
  transform: 'translateY(-50%)'
};
export var variantPrimary = {
  button: {
    bg: 'red.500',
    borderColor: 'red.500',
    borderRadius: 0,
    color: 'white',
    _focus: {
      bg: '#FFD530',
      borderColor: 'grey.950',
      boxShadow: "0 0 0 0 rgba(31, 31, 31, 1)",
      color: 'grey.980',
      outline: 'none'
    },
    _hover: {
      bg: 'red.400',
      borderColor: 'red.400',
      color: 'white'
    },
    _active: {
      bg: '#FFD530',
      borderColor: 'grey.950',
      color: 'grey.980'
    },
    _disabled: {
      bg: 'grey.500',
      borderColor: 'grey.500',
      color: 'white'
    }
  }
};
export var variantSecondary = {
  button: {
    borderColor: 'blue.600',
    borderRadius: 0,
    color: 'blue.600',
    _focus: {
      bg: '#FFD530',
      borderColor: 'grey.950',
      color: 'grey.980',
      boxShadow: '0 0 0 0 rgba(0, 0, 0, 1)',
      outline: 'none',
      borderWidth: '2px'
    },
    _hover: {
      bg: 'blue.600',
      color: 'white'
    },
    _active: {
      bg: '#FFD530',
      borderColor: 'grey.950',
      color: 'grey.980'
    },
    _disabled: {
      bg: 'grey.500',
      borderColor: 'grey.500',
      color: 'white'
    }
  }
};
export var variantTertiary = {
  button: {
    border: 'none',
    borderRadius: 0,
    color: 'blue.600',
    bg: 'white',
    minW: {
      base: '0',
      md: '0'
    },
    _focus: {
      bg: '#FFD530',
      color: 'black',
      border: 'none',
      boxShadow: '0 0 0 0 rgba(0, 0, 0, 1)',
      outline: 'none'
    },
    _hover: {
      bg: 'blue.600',
      color: 'white'
    },
    _active: {
      bg: '#FFD530',
      color: 'black'
    },
    _disabled: {
      bg: 'grey.500',
      color: 'white'
    }
  },
  leftIcon: _objectSpread(_objectSpread({}, iconSharedStyles), {}, {
    left: '1rem'
  }),
  rightIcon: _objectSpread(_objectSpread({}, iconSharedStyles), {}, {
    right: '1rem'
  }),
  spinner: _objectSpread(_objectSpread({}, iconSharedStyles), {}, {
    right: '1rem'
  })
};
export var Button = asSingleStyleConfig({
  baseStyle: {
    button: {
      borderRadius: 0,
      border: '2px',
      fontWeight: 'semibold',
      lineHeight: 'button',
      letterSpacing: 'tight',
      minW: {
        base: '0',
        md: '0'
      },
      _hover: {
        textDecoration: 'none'
      }
    }
  },
  variants: {
    primary: variantPrimary,
    secondary: variantSecondary,
    tertiary: variantTertiary,
    danger: variantPrimary // the wales theme doesn't have a 'danger' variant, but use primary in its place
  },

  sizes: {
    md: props => {
      var {
        rightIcon,
        leftIcon,
        isLoading
      } = props;
      return {
        button: {
          minW: {
            base: '0',
            md: '0'
          },
          pl: leftIcon ? '2.875rem' : '1.25rem',
          pr: rightIcon || isLoading ? '2.875rem' : '1.25rem',
          height: '3.125rem'
        }
      };
    },
    sm: props => {
      var {
        rightIcon,
        leftIcon,
        isLoading
      } = props;
      return {
        button: {
          minW: {
            base: '0',
            md: '0'
          },
          pl: leftIcon ? '2.25rem' : '1rem',
          pr: rightIcon || isLoading ? '2.25rem' : '1rem',
          fontSize: 'sm'
        }
      };
    },
    xs: props => {
      var {
        rightIcon,
        leftIcon,
        isLoading
      } = props;
      return {
        button: {
          minW: {
            base: '0',
            md: '0'
          },
          pl: leftIcon ? '2rem' : '1rem',
          pr: rightIcon || isLoading ? '2rem' : '1rem'
        }
      };
    }
  }
});